//
// Generated class ReactivationReasonLog
//

/// <reference path="ReactivationReasonLog_ManagedObject.ts" />

class ReactivationReasonLog extends ReactivationReasonLog_ManagedObject
{

}
